// extracted by mini-css-extract-plugin
export var angleRight = "article-overview-module--angle-right--DBp3v";
export var clockIcon = "article-overview-module--clock-icon--dSl3q";
export var container = "article-overview-module--container--Ii9I8";
export var continueReading = "article-overview-module--continue-reading--GMxCR";
export var date = "article-overview-module--date--XPH4r";
export var featureImage = "article-overview-module--feature-image--JK9GK";
export var header = "article-overview-module--header--kTlDE";
export var summary = "article-overview-module--summary--oB8NX";